/**
 * Application Name: Sahajaseeds-WAS
 * Author: Zevcore Private Limited
 * Starting date: 15.12.2022
 * Developer Name: Anand Krishna
 * Last modified date: 15.12.2022
 * Last modified by: Anand Krishna
 */

import { Button } from "@mantine/core"; //For import mantine required functions and theme
import React, { Component } from "react";
import { ArrowBackUp } from "tabler-icons-react"; // For particular icons that has used in this page from tabler icon
import ERROR from "../assets/images/error.png"; // Error image

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, info) {
    this.setState({ error: error, errorInfo: info });
  }

  // For return back to home page dashboard
  handleClick() {
    try {
      window.location.href = "/";
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <div className="error-boundary">
          <summary>Something went wrong</summary>
          {/* Show all the details of error in dropdown */}
          <details style={{ whiteSpace: "pre-wrap" }}>
            {this.state.error && this.state.error.toString()}
            {this.state.errorInfo.componentStack}
          </details>
          <div
            style={{
              margin: "auto",
            }}
          >
            <img src={ERROR} width={400}></img>
          </div>

          {/* Custom name and image to display whenever error accord */}
          <div className="text">
            <h4>Something went wrong on this page</h4>
            <p>
              Some error occurred you can see details and fix it. <br /> Due to
              some error occurred on this page cannot be able to render retry
              again or contact us.
            </p>
            <Button mt={25} mb={50} onClick={this.handleClick}>
              Return to home dashboard &nbsp; &nbsp;
              <ArrowBackUp />
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
